module.exports = __webpack_public_path__ + "img/zhang.f32ce5fe.png";